import React from 'react';

const AdminSidebar = ({ activeTab, setActiveTab }) => {
  return (
    <div className="sidebar">
      <h2>Admin Panel</h2>
      <ul>
        <li
          className={activeTab === 'users' ? 'active' : ''}
          onClick={() => setActiveTab('users')}
        >
          <i className="bi bi-person-circle"></i> Korisnici
        </li>
        <li
          className={activeTab === 'reservations' ? 'active' : ''}
          onClick={() => setActiveTab('reservations')}
        >
          <i className="bi bi-calendar-check"></i> Rezervacije
        </li>
        <li
          className={activeTab === 'subjects' ? 'active' : ''}
          onClick={() => setActiveTab('subjects')}
        >
          <i className="bi bi-pencil"></i> Predmeti
        </li>
        <li
          className={activeTab === 'chat' ? 'active' : ''}
          onClick={() => setActiveTab('chat')}
        >
          <i className="bi bi-chat-dots"></i> Poruke
        </li>
      </ul>
    </div>
  );
};

export default AdminSidebar;